import LecturerNav from "../../navigation/LecturerNav";
import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from 'react-redux';
import { createLecturerProjects, updateLecturerProject, getLecturerProjects, deleteLecturerProject } from '../../actions/lecturerprojects';
import { Grid, CircularProgress, Button } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ClearIcon from '@material-ui/icons/Clear';

/**
 * This page presents the lecturer with a form to fill out to allow them to input their own project suggestions.
 * When the project is submitted it will automatically show up on the screen which lets them know it submitted properly and be sent to the 
 * lecturer projects collection in the database.
 * If they already have submitted projects they are allowed to either edit or delete that project.
 * @returns the project creation form along with the projects that was created by the lecturer.
 */

function LecturerCreateEditProject() {
    const [lecturerProjects, setlecturerProject] = useState({
        title: '', description: ''
    });

    const [id, setID] = useState(null);

    let projects = []
    const userProject = [];

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getLecturerProjects());
      }, [dispatch, lecturerProjects]);

    /**
     * the submitHandler function checks if there is an id and if there is it then carries out the updatelecturerproject function to edit.
     * if there isn't an id then a project is created instead and send to the lectuer projects collection
     * @param {*} e is the event recieved from the component
     */

    const submitHandler = (e) => {
        e.preventDefault();

        if(id) {
            dispatch(updateLecturerProject(id, lecturerProjects));
        } else {
            const assigning = Object.assign({}, lecturerProjects)
            assigning.userID = localStorage.getItem("id")
            dispatch(createLecturerProjects(assigning));
            alert("Project successfully submitted")
        }
        clearFields();
    }

    const handleProjectEdit = (project) => {
        const newProject = Object.assign({}, lecturerProjects)

        newProject.title = project.title;
        newProject.description = project.description;
        newProject.userID = localStorage.getItem("id");

        setID(project._id)
        setlecturerProject(newProject);
    }

    const clearFields = () => {
        setID(null);
        setlecturerProject({title: '', description: ''});
    }

    const response = useSelector((state) => state.lecturerprojects.data);
    if (response){
        projects = Array.from(response);
        projects.forEach(project => {
            if(project.userID === localStorage.getItem("id")) {
                userProject.push(project);
            }
        })
    }

    return(
        <div className="createProjectContainer">
            <LecturerNav/>
            <form id={id} onSubmit={submitHandler}>
               <h1>{id ? 'Edit Project' : 'Create Project'}</h1>
               <p>Enter project details below:</p>
               <label>
                   Project Name: 
                   <input type="text" name="title" label="Name" value={lecturerProjects ? lecturerProjects.title : ''} onChange={(e) => setlecturerProject({...lecturerProjects, title: e.target.value})}></input>
               </label>
               <label>
                   Project Description: 
                   <input type="text" name="description" label="Description" value={lecturerProjects ? lecturerProjects.description : ''} onChange={(e) => setlecturerProject({...lecturerProjects, description: e.target.value})}></input>
               </label>
               <input className="submitButton" type="submit" name="submit" onClick={() => {}}></input>
               <Button onClick={clearFields}>
                    <ClearIcon/>
                    Clear
                </Button>
           </form>
           {!projects.length ? <CircularProgress /> : (
                <Grid >
                    {userProject.map((project) => (
                        <Grid className="paper" key={project._id} item>
                            <p>{project.title}</p>
                            <p>{project.supervisor}</p>
                            <p>{project.description}</p>
                            <Button onClick={() => handleProjectEdit(project)}>
                                <EditIcon/>
                                Edit
                            </Button>
                            <Button onClick={() => dispatch(deleteLecturerProject(project._id))}>
                                <DeleteIcon/>
                                Delete
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            )}
        </div>
    )
}

export default LecturerCreateEditProject;